import { useMutation } from 'react-query'
import { ContactRepository } from 'repository/contact'
import { ContactParams } from 'models/contact'

export const useSendContactForm = () => {
  return useMutation((data: ContactParams) => ContactRepository.contact(data))
}
